// /app/frontend/src/components/compliance/map/DataFlowEdge.jsx
import React from 'react';
import { BaseEdge, EdgeLabelRenderer, getBezierPath } from 'reactflow';

const DataFlowEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
  markerEnd,
  style,
}) => {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        markerEnd={markerEnd}
        style={{
          ...style,
          stroke: '#475569',
          strokeWidth: 2,
          strokeDasharray: data?.dashed ? '5,5' : 'none',
        }}
      />
      
      {/* Animated particle along the edge */}
      <circle r="4" fill="#8b5cf6" className="animate-pulse">
        <animateMotion dur="3s" repeatCount="indefinite" path={edgePath} />
      </circle>
      
      {/* Edge Label */}
      {data?.label && (
        <EdgeLabelRenderer>
          <div
            style={{
              position: 'absolute',
              transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
              pointerEvents: 'all',
            }}
            className="px-2 py-1 text-[10px] font-medium rounded bg-slate-900 text-slate-400 border border-slate-700 shadow-lg"
          >
            {data.label}
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
};

export default DataFlowEdge;
